import { render, staticRenderFns } from "./Aplicacoes.vue?vue&type=template&id=523782dc&scoped=true"
import script from "./Aplicacoes.vue?vue&type=script&lang=js"
export * from "./Aplicacoes.vue?vue&type=script&lang=js"
import style0 from "./Aplicacoes.vue?vue&type=style&index=0&id=523782dc&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "523782dc",
  null
  
)

export default component.exports